@if(loading){<lib-spinner-overlay></lib-spinner-overlay>}
@for(debtor of debtorList; track debtor.DebitorID){
<mat-card appearance="outlined" [routerLink]="'/debtor/' + debtor.DebitorID">
    <mat-card-header>
        <mat-card-title>{{debtor.Name}}</mat-card-title>
        <mat-card-subtitle>{{debtor.Nummer}}</mat-card-subtitle>
    </mat-card-header>
        <mat-card-content>
            <mat-list>
                @if(debtor.Strasse){ <mat-list-item><span style="font-weight: bold">{{language.Strasse | translationPipe}}: </span><span>{{debtor.Strasse}}</span> </mat-list-item>} 
                @if(debtor.PLZ || debtor.Ort){ <mat-list-item><span style="font-weight: bold">{{language.PLZ | translationPipe}}/{{language.Ort  | translationPipe}}: </span><span>{{debtor.PLZ}} {{debtor.Ort}}</span></mat-list-item>} 
            </mat-list>
        </mat-card-content>            
</mat-card>
}